import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ServiceMessageComponent } from '@core/components/service-message/service-message.component';
import { DEFAULT_DIALOG_CONFIG, SereviceMessageType } from '@core/constants/serviceMessage.const';
import { IApp } from '@core/models/app.interfaces';
import { IDisplayMessages } from '@core/models/serviceMessage.model';
import { LookupService } from '@core/services/lookup.service';
import { ModalService } from '@shared/services/modal.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StoreService } from '@core/store/store.service';
import { WCAGLabelDirective } from '@shared/directives/wcag-label.directive';
import { NgSelectModule } from '../ng-select/ng-select.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-select-accounts',
  templateUrl: './select-accounts.component.html',
  styleUrls: ['./select-accounts.component.scss'],
  imports:[WCAGLabelDirective, NgSelectModule, CommonModule, TranslateModule, FormsModule]
})
export class SelectAccountsComponent implements OnInit {

  @Input() items: IApp.ILookup[];
  @Input() formEnabled: boolean;
  @Input() canDeleteAccount: boolean;
  @Output() listChanged = new EventEmitter<IApp.ILookup[]>();

  private _destroy$ = new Subject<any>();
  private _facilityNames: IApp.ILookup[] = [];
  public facilityNames: IApp.ILookup[] = [];

  public dummy: IApp.ILookup;

  constructor(
    private lookupService: LookupService,
    private modalService: ModalService,
    private store: StoreService,
  ) { }

  ngOnInit() {
    this.getFacilityNames();
    this.store.accountFacilities$.pipe(
        takeUntil(this._destroy$),
      )
      .subscribe(
        () => {
          this.getFacilityNames();
        },
      );
  }

  getFacilityNames() {
    this.lookupService.getFacilityNames().pipe(
      takeUntil(this._destroy$),
    ).subscribe(value => {
      this._facilityNames = value;
      this.updateList();
    });
  }

  addItem(data) {
    if (data) {
      this.items.unshift(data);
      this.updateList();
      this.listChanged.emit(this.items);
    }
    setTimeout(() => this.dummy = null);
  }

  removeItem(event, id) {
    event.preventDefault();
    if (!this.canDeleteAccount) {
      this.showError();
      return;
    }
    this.items.splice(id, 1);
    this.updateList();
    this.listChanged.emit(this.items);
  }

  private updateList() {
    this.facilityNames = this._facilityNames.filter(f => !this.items.map(i => i.id).includes(f.id));
  }

  private showError() {
    const messages: IDisplayMessages = {
      messages: [{message: 'aoCanotBeDeleted'}],
      type: SereviceMessageType.ERROR,
    };
    this.modalService.open(ServiceMessageComponent, messages, true, DEFAULT_DIALOG_CONFIG)
      .afterClosed()
      .subscribe();
  }

}
